import { InputTypes, SelectOptionItem } from './paymentForm.model';

export interface PaymentMethodCategory {
  id: string;
  name: string;
  label: string;
}

export interface CategoryAggregate {
  name: string;
  label: string;
  paymentMethods: PaymentMethodBase[];
}

export interface InputMetaData {
  pattern?: string;
  errorMessage?: string;
  preprocessed?: boolean;
  scale?: number;
  options: SelectOptionItem[];
  min?: number;
  max?: number;
  currency?: string; // smells very bad because input validator knows about Domain
  balance?: number; // smells very bad because input validator knows about Domain
  shouldBeStripped?: boolean;
  yearFormat?: 'YY' | 'YYYY';
}

export interface PaymentMethodInput {
  name: string;
  required: boolean;
  type: InputTypes;
  value: string | boolean | Array<string> | null;
  label?: string;
  placeholder?: string;
  mask?: string;
  errorMsg?: string;
  isValid?: boolean;
  isFocused?: boolean;
  isEmpty?: boolean;
  params?: InputMetaData;
}

export interface PaymentAttribute {
  name: string;
  value: string | boolean | Array<string> | null;
  isValid: boolean;
}

export enum IntegrationSources {
  Internal = 'internal',
  External = 'external',
}

interface FieldInterface extends PaymentMethodInput {
  componentName: string;
}

export interface FieldsByTypeInterface extends FieldInterface {
  cvv?: FieldInterface;
  expirationDate?: FieldInterface;
  cardHolder?: FieldInterface;
  creditcardNumber?: FieldInterface;
}

export interface PaymentMethodRules {
  min: number | null;
  max: number | null;
  recommended: boolean;
  amounts: string[];
}

export interface PaymentMethodRestriction {
  type: string;
  message: string;
}

//@TODO: maybe it would be more effective to use enum instead
export type NextStepType = 'display' | 'html' | 'form' | 'redirect';
export type NextStepContainer = 'window' | 'iframe';

export interface NextStep {
  nullable: boolean;
  types: NextStepType[];
  containers: NextStepContainer[];
}

export interface NextStepInfo {
  post_process: null | NextStep;
  post_confirm: null | NextStep;
  channel: null | NextStep;
}

export interface PliromyPreprocessorParameters {
  preprocessorUrl: string;
  password: string;
  username: string;
}

export interface PiqPreprocessorParameters {
  preprocessorUrl: string;
  paymentIqMerchantId: string;
}

export interface FinteqHubPreprocessorParameters {
  pspMerchantId: string;
  preprocessorUrl: string;
}

export interface PreprocessorParam {
  type: string;
  parameters:
    | PiqPreprocessorParameters
    | PliromyPreprocessorParameters
    | FinteqHubPreprocessorParameters;
}

export interface PaymentMethodBase {
  id: string;
  name: string;
  categories: string[];
  recommended: boolean;
  logo: string;
  order?: number;
}

export enum RedirectContainers {
  NO_REDIRECT = 'NO_REDIRECT',
  IFRAME = 'IFRAME',
  NEW_TAB = 'NEW_TAB',
}

export interface PaymentMethodConfiguration {
  id: string;
  name: string;
  vendor: string;
  referenceId: string;
  activeInputs: PaymentMethodInput[];
  account_form_inputs: PaymentMethodInput[];
  inputs: PaymentMethodInput[];
  categories: PaymentMethodCategory[];
  ruleParams?: PaymentMethodRules;
  description?: string;
  source: IntegrationSources | null;
  preprocessor: PreprocessorParam | null;
  logo: string;
  //TODO: rename fields to camelCase analogues
  display_form_description?: string;
  final_screen_description?: string;
  next_step_info: NextStepInfo;
  show_account_form?: boolean;
  //TODO: remove in a nearest future
  hideAmount: boolean;
  redirectContainer: RedirectContainers;
  restriction?: PaymentMethodRestriction | null;
}
